module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-team-calendar__header"
  }, [_c('div', {
    staticClass: "d-team-calendar__header__header"
  }, [_c('div', {
    staticClass: "d-team-calendar__header__header__left team-d-tabs"
  }, [_c('div', {
    staticClass: "team-d-tabs__tab",
    class: {
      'team-d-tabs__tab--active': _vm.theTab === 1
    },
    on: {
      "click": function($event) {
        return _vm.setTab(1)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale]['custom']) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "team-d-tabs__tab",
    class: {
      'team-d-tabs__tab--active': _vm.theTab === 2
    },
    on: {
      "click": function($event) {
        return _vm.setTab(2)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale]['shortcuts']) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "d-team-calendar__header__header__right"
  }, [_c('button', {
    staticClass: "marg-5-right",
    class: [{
      inactive: _vm.isToday
    }, 'no-print'],
    on: {
      "click": _vm.today
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('repitition.today')) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "icon-arrow-left4 no-print marg-5-right",
    on: {
      "click": _vm.prev
    }
  }), _vm._v(" "), _c('DatePicker', {
    attrs: {
      "popperPlacement": "bottom-end",
      "date": _vm.date
    },
    on: {
      "changed": _vm.setDate
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "icon-arrow-right4 no-print marg-5-left",
    on: {
      "click": _vm.next
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.theTab === 1),
      expression: "theTab === 1"
    }],
    staticClass: "team-d-tabs__tab__content"
  }, [_c('dSelectAll', {
    staticClass: "marg-1-bottom",
    attrs: {
      "show-tags": true,
      "showCreateButton": false,
      "itemsSelected": _vm.itemsSelected
    },
    on: {
      "add": function($event) {
        return _vm.dSelectUsersUpdated('add')
      },
      "remove": function($event) {
        return _vm.dSelectUsersUpdated('remove')
      },
      "update": function($event) {
        return _vm.dSelectUsersUpdated('update', $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cal-container__header"
  }, [_c('div', {
    staticClass: "cal-container__header--left"
  }, [_c('div', {
    staticClass: "d-cal-views"
  }, [_c('div', {
    staticClass: "d-cal-views__view",
    class: {
      'd-cal-views__view--active': _vm.getIsView('resourceTimeGridDay')
    },
    on: {
      "click": function($event) {
        return _vm.setView('resourceTimeGridDay')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['show_day']) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "d-cal-views__view",
    class: {
      'd-cal-views__view--active': _vm.getIsView('resourceTimeGridFiveDay')
    },
    on: {
      "click": function($event) {
        return _vm.setView('resourceTimeGridFiveDay')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['show_week']) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "d-cal-views__view",
    class: {
      'd-cal-views__view--active': _vm.getIsView('overlayWeek')
    },
    on: {
      "click": function($event) {
        return _vm.setView('overlayWeek')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['show_overlay_week']) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "d-cal-views__view",
    class: {
      'd-cal-views__view--active': _vm.getIsView('listView')
    },
    on: {
      "click": function($event) {
        return _vm.setView('listView')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['show_list']) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "d-cal-views__view",
    class: {
      'd-cal-views__view--active': _vm.getIsView('schedulerView')
    },
    on: {
      "click": function($event) {
        return _vm.setView('schedulerView')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['show_scheduler']) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "d-cal-views__view",
    class: {
      'd-cal-views__view--active': _vm.getIsView('presenceTable')
    },
    on: {
      "click": function($event) {
        return _vm.setView('presenceTable')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['show_presence_table']) + "\n          ")])]), _vm._v(" "), (_vm.calview !== 'schedulerView' && _vm.calview !== 'presenceTable') ? _c('DDropdown', {
    attrs: {
      "isShowDots": false
    }
  }, [_c('button', {
    staticClass: "d-teamcalendar__saved-views__scroll bttn-simple",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n            " + _vm._s(_vm.theSelectedScrollOption) + "\n            "), _c('svg', {
    staticClass: "w-6 h-6",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M12.53 16.28a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 011.06-1.06L12 14.69l6.97-6.97a.75.75 0 111.06 1.06l-7.5 7.5z",
      "clip-rule": "evenodd"
    }
  })])]), _vm._v(" "), _c('ul', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, _vm._l((_vm.scrollOptions), function(view) {
    return _c('li', {
      staticClass: "d-teamcalendar__saved-views__view",
      on: {
        "click": function($event) {
          return _vm.setSelectedScrollOption(view)
        }
      }
    }, [_vm._v("\n              " + _vm._s(view.title) + "\n            ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.calview == 'resourceTimeGridDay' || _vm.calview == 'resourceTimeGridFiveDay') ? _c('button', {
    staticClass: "marg-5-left",
    on: {
      "click": _vm.setIsShowSettings
    }
  }, [_c('span', {
    staticClass: "icon-wrench"
  })]) : _vm._e(), _vm._v(" "), (_vm.calview !== 'schedulerView') ? _c('button', {
    staticClass: "marg-5-left",
    on: {
      "click": _vm.print
    }
  }, [_c('span', {
    staticClass: "icon-printer3"
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "bttn-with-svg",
    on: {
      "click": function($event) {
        return _vm.$emit('updateEvents')
      }
    }
  }, [_c('svg', {
    staticClass: "w-6 h-6",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke-width": "1.5",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
    }
  })])]), _vm._v(" "), (_vm.isDragAndDropPossible && (_vm.calview == 'resourceTimeGridDay' || _vm.calview == 'resourceTimeGridFiveDay')) ? _c('div', {
    staticClass: "d-team-calendar__header__drag-toggle marg-5-left no-print",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('setIsDragAndDropOn', !_vm.isDragAndDropOn)
      }
    }
  }, [_c('AppToggle', {
    attrs: {
      "propOn": _vm.isDragAndDropOn,
      "allowChanges": false
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['edit_schedules']))])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.isShowSettings) ? _c('DModal', {
    attrs: {
      "show-close": false,
      "isBgOverlay": true
    }
  }, [_c('div', {
    staticClass: "d-modal",
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.standard_settings.standard_setting')))]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__close icon__bg-circle",
    on: {
      "click": function($event) {
        _vm.isShowSettings = false
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('div', {
    staticClass: "d-input-group marg-1-bottom"
  }, [_c('label', {
    staticClass: "d-input marg-05-bottom"
  }, [_vm._v(_vm._s(_vm.$t('vue2.standard_settings.set_default_start_and_endtime')))]), _vm._v(" "), _c('TimeChanger', {
    staticClass: "marg-1-top",
    attrs: {
      "showIcon": true,
      "start": _vm.standardStartTime,
      "end": _vm.standardEndTime
    },
    on: {
      "updateStart": _vm.setStandardStartTime,
      "updateEnd": _vm.setStandardEndTime
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-input-group d-input-group__is-toggle"
  }, [_c('div', {
    staticClass: "d-input-group__toggle",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setCustomNumberOfDays(!_vm.isSetCustomNumberOfDays)
      }
    }
  }, [_c('label', {
    staticClass: "d-input"
  }, [_vm._v("Set custom number of days")]), _vm._v(" "), _c('AppToggle', {
    attrs: {
      "propOn": _vm.isSetCustomNumberOfDays
    }
  })], 1), _vm._v(" "), (_vm.isSetCustomNumberOfDays) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.numberOfDays),
      expression: "numberOfDays"
    }],
    ref: "input_custom_number_of_days",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.numberOfDays)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.numberOfDays = $event.target.value
      }
    }
  }) : _vm._e()]), _vm._v(" "), (!_vm.isSetCustomNumberOfDays) ? _c('div', {
    staticClass: "d-input-group d-input-group__is-toggle",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setIsShowWeekends(!_vm.isShowWeekends)
      }
    }
  }, [_c('div', {
    staticClass: "d-input-group__toggle"
  }, [_c('label', {
    staticClass: "d-input"
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.show_weekends')))]), _vm._v(" "), _c('AppToggle', {
    attrs: {
      "propOn": _vm.isShowWeekends,
      "allowChanges": false
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons pad-1"
  }, [_c('button', {
    staticClass: "bttn bttn-simple marg-1-right",
    on: {
      "click": function($event) {
        _vm.isShowSettings = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "bttn submit-button",
    on: {
      "click": _vm.submitStandardSettings
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')))])])])]) : _vm._e(), _vm._v(" "), _c('TeamCalendarHeaderSaveView', {
    attrs: {
      "itemsSelected": _vm.itemsSelected
    },
    on: {
      "setSavedView": _vm.setSavedView
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.theTab === 2),
      expression: "theTab === 2"
    }],
    staticClass: "team-d-tabs__tab__content team-d-tabs__tab__content__header"
  }, [_c('div', {
    staticClass: "d-cal-views"
  }, [_c('div', {
    staticClass: "d-cal-views__view",
    class: {
      'd-cal-views__view--active': _vm.getIsView('scheduler__all_cals')
    },
    on: {
      "click": function($event) {
        return _vm.setView('scheduler__all_cals')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale]['all_calendars']) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "d-cal-views__view",
    class: {
      'd-cal-views__view--active': _vm.getIsView('scheduler__all_klass')
    },
    on: {
      "click": function($event) {
        return _vm.setView('scheduler__all_klass')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale]['all_classes']) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "d-cal-views__view",
    class: {
      'd-cal-views__view--active': _vm.getIsView('scheduler__all_users')
    },
    on: {
      "click": function($event) {
        return _vm.setView('scheduler__all_users')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale]['all_users']) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "d-cal-views__view",
    class: {
      'd-cal-views__view--active': _vm.getIsView('scheduler')
    },
    on: {
      "click": function($event) {
        return _vm.setView('scheduler')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale]['room_overview']) + "\n      ")]), _vm._v(" "), (_vm.userHasPermission('can_do_most_stuff')) ? [_c('div', {
    staticClass: "d-cal-views__view",
    class: {
      'd-cal-views__view--active': _vm.getIsView('doubleBookings')
    },
    on: {
      "click": function($event) {
        return _vm.setView('doubleBookings')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.i18n[_vm.locale]['show_double_bookings']) + "\n        ")])] : _vm._e()], 2), _vm._v(" "), (_vm.calview !== 'doubleBookings') ? [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['sort_by']))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.theSortOptionForAllSchedules),
      expression: "theSortOptionForAllSchedules"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.theSortOptionForAllSchedules = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.setChangedSortOption(_vm.theSortOptionForAllSchedules)
      }]
    }
  }, _vm._l((_vm.sortOptionsForAllSchedules), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.title))])
  }), 0)] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5047da95!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TeamCalendar/TeamCalendarHeader.vue
// module id = 1913
// module chunks = 1